import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import membershipReducer, { initialState } from '../reducers/membershipReducer';

export const MembershipContext = createContext();

const MembershipProvider = ({ children }) => {
  const useMembershipState = useReducer(membershipReducer, initialState);

  return (
    <MembershipContext.Provider value={[...useMembershipState]}>
      <ContextDevTool
        context={MembershipContext}
        id="MembershipContext"
        displayName="Membership Context"
      />
      {children}
    </MembershipContext.Provider>
  );
};

MembershipProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default MembershipProvider;
